import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownExtraServiceInfo', request)
}

export {get}
